class HyperlinkComponent {
  constructor() {
    Object.assign(this, {
      url_to: 'products',
      url_text: '',
      url_data: {},
      isClinicLink: true,
    });
  }

  openHyperlinkForm($mdMenu, event) {
    $mdMenu.open(event);
  }

  cancel($mdMenu) {
    this.url_text = '';
    this.url_to = 'products';
    this.url_data = {};
    this.isClinicLink = true;
    $mdMenu.close();
  }

  isClinicLinkChange() {
    this.url_to = this.isClinicLink
      ? 'products'
      : '';
    this.url_data = {};
  }

  validate() {
    return this.url_text !== ''
      && (!this.isClinicLink && this.url_to !== '');
  }

  insert($mdMenu) {
    $mdMenu.close();
    this.onInsertHyperlink({
      isClinicLink: this.isClinicLink,
      url_to: this.url_to,
      url_text: this.url_text,
      url_data: this.url_data
    });
  }
}

angular.module("pims").component('hyperlinkToolbox', {
  templateUrl: 'app/components/text-formatter-toolbox/hyperlink/hyperlink.component.html',
  controller: HyperlinkComponent,
  controllerAs: 'vm',
  bindings: {
    onInsertHyperlink: '&',
  },
});
